import { env } from "@/env";
import { formatApiError } from "@/lib/api/_fetch";

export interface RetrieveReportsResult {
  ok: boolean;
  message: string;
}

/**
 * Self-serve report retrieval. The buyer enters the phone or email they used at
 * checkout; the backend re-sends their purchased report link(s) to that contact's own
 * WhatsApp / email. The response is intentionally generic — it never reveals
 * whether the contact had any reports (anti-enumeration), so nothing is shown
 * on screen except the confirmation message.
 */
export async function retrieveReports(contact: string): Promise<RetrieveReportsResult> {
  const res = await fetch(`${env.NEXT_PUBLIC_API_URL}/reports/retrieve`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ contact }),
  });
  const body = (await res.json().catch(() => ({}))) as Partial<RetrieveReportsResult>;
  if (!res.ok) {
    throw new Error(formatApiError(body, res.status) || `HTTP ${res.status}`);
  }
  return { ok: Boolean(body.ok), message: body.message ?? "" };
}
